<div [ngClass]="'navigation-item' + (isSelected ? ' navigation-item--selected' : '') + ' ' + currrentCampaignPage || ''">
  <div class="navigation-item__dimmer">
    @if (!isButton && !isProfilesSubmenuItem && !isSurveysSubmenuItem) {
      <a class="navigation-item__link" mat-button [routerLink]="url" [queryParams]="query" [attr.data-test]="dataTest">
        @if (isBetaItem) {
          <span class="beta">BETA</span>
        }
        @if (isNew) {
          <span class="new-addon">NEW</span>
        }
        @if (adminOnly) {
          <mat-icon class="admin-only-tag-sub">font_download</mat-icon>
        }
        <span class="navigation-item__label">{{ translationKey | translate }}</span>
        @if (showUpgradeTag) {
          <app-account-upgrade-tag></app-account-upgrade-tag>
        }
      </a>
    }
    @if (
      !isButton && ((isProfilesSubmenuItem && activeUrl?.startsWith("/profiles")) || (isSurveysSubmenuItem && activeUrl?.startsWith("/campaigns/surveys")))
    ) {
      <a class="navigation-item__link sub" mat-button [routerLink]="url" [queryParams]="query" [attr.data-test]="dataTest">
        @if (isBetaItem) {
          <span class="beta navigation-item__label">BETA</span>
        }
        <span class="navigation-item__label">{{ translationKey | translate }}</span>
      </a>
    }
    @if (isButton) {
      <button mat-stroked-button class="navigation-item__button" [routerLink]="url" [attr.data-test]="dataTest">
        <span class="navigation-item__label">{{ translationKey | translate }}</span>
      </button>
    }
  </div>
</div>
